module.exports = __webpack_public_path__ + "static/img/11.4fe5047.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/zh/11.png
// module id = Pkho
// module chunks = 0